import React, { 
  useCallback, 
  useMemo, 
  useState,
  useEffect,
 } from 'react';

import axios from 'axios';

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

import type {
  MRT_ColumnDef,
  MRT_Cell,
  MRT_Row,
  MRT_TableOptions,
} from 'material-react-table';

// import {
//   useMaterialReactTable,
//   MaterialReactTable,
//   type MRT_TableOptions,
//   type MRT_Cell,
//   type MRT_ColumnDef,
//   type MRT_Row,
// } from 'material-react-table';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
  FormControl,
  Alert,
  AlertTitle,
  Grid,

} from '@mui/material';
import { Delete, Edit, ThumbUpAlt, ThumbDownAlt, QuestionMark } from '@mui/icons-material';

// import { Modal, Button } from 'react-bootstrap';

import ConfirmationDialogRaw from'./confirmation-dialog-raw'

import {hasUniqueCombination} from '../../functions/HasUniqueCombinations'

import {CQADataType} from './data-definition'
import {ProctorCompactionTest} from '../proctor_inputs/data-definition'

import {CreateUpdateRecordModal} from './create-update-record-modal'

import MapLoadingComponent from '../map/map-loading-component'


export const CQADataTypeData: CQADataType[] = [
];
export const ProctorCompactionTestData: ProctorCompactionTest[] = [
];


interface SetValuesProps {
  showDialog: any;
  currentGridID: any;
  currentGridData: any;
  getCurrentGridData: any;
}



const FillGridCQAInputTable = (props: SetValuesProps) => {

    const {showDialog, currentGridID, currentGridData, getCurrentGridData} = props;
    const [isLoading, setIsLoading] = useState(false);

    const [initialElevation, setInitialElevation] = useState(
      currentGridData.hasOwnProperty("initialElevation") && currentGridData["initialElevation"] !== "" 
        ? currentGridData["initialElevation"] 
        : 0
    );
    // const [currentElevation, setCurrentElevation] = useState(0);

    const [currentElevation, setCurrentElevation] = useState(
      currentGridData.hasOwnProperty("elevation") && currentGridData["elevation"] !== "" 
        ? currentGridData["elevation"] 
        : 0
    );

    const [createModalOpen, setCreateModalOpen] = useState(false);

    const [tableData, setTableData] = useState<CQADataType[]>(() => CQADataTypeData);
    const [proctorTableData, setProctorTableData] = useState<ProctorCompactionTest[]>(() => ProctorCompactionTestData);

//  Alert:
const [showAlert, setShowAlert] = useState(true);

type AlertType = "error" | "info" | "success" | "warning" | undefined;
const [inputAlertType, SetInputAlertType] = useState("success" as AlertType);
const [inputAlertText, SetInputAlertText] = useState("Changes saved!");    
const [updateDBSuccess, setUpdateDBSuccess] = useState(true);

//  Update currentElevation when tableData changes:

function calcCurrentSurveyElevation(tableData: any[]) {
  if (tableData.length > 0) {
    const sortedTableData = [...tableData].sort((a, b) => {
      const dateA = new Date(a.date) as Date;
      const dateB = new Date(b.date) as Date;
    
      if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
        return 0;
      } else {
        return dateB.getTime() - dateA.getTime();
      }
    });
    
    const latestDate = sortedTableData[0].date;
    const latestDateObjects = sortedTableData.filter(obj => 'surveyElevation' in obj && obj.surveyElevation.toString() !== "");

    if (latestDateObjects.length > 0) {
      const isIncreasing = latestDateObjects[0].surveyElevation > latestDateObjects[0].previousSurveyElevation;
      let surveyElevation;
      
      if (isIncreasing) {
        surveyElevation = Math.max(...latestDateObjects.map(obj => parseFloat(obj.surveyElevation.toString())).filter(num => !isNaN(num)));
      } else {
        surveyElevation = Math.min(...latestDateObjects.map(obj => parseFloat(obj.surveyElevation.toString())).filter(num => !isNaN(num)));
      }

      return surveyElevation;
    }
  }

  return null;
}


useEffect(() => {
  console.log(tableData)
  const currentSurveyElevation = calcCurrentSurveyElevation(tableData);
  if (currentSurveyElevation !== null) {
    setCurrentElevation(currentSurveyElevation);
  };

}, [tableData]);

const proctorDBUrl = process.env.REACT_APP_CQA_PROCTOR_DB_URL;      

//  Load Proctor data from DB:

  useEffect(() => {
  if (showDialog===true) {
    setIsLoading(true)

    axios.get(process.env.REACT_APP_BACKEND_URL + proctorDBUrl).then(function (response) {
      if (response.data) {
        // console.log(response.data)
        setProctorTableData(response.data)
        SetInputAlertType("success")
        SetInputAlertText("Data successfully loaded from Cloud!")
      } else {
        setProctorTableData([])
      }
    })
    .catch(function (error) {
      // handle error
      console.log(error);
      // setIsLoading(false)
      SetInputAlertType("error")
      SetInputAlertText(error)
    })
    .then(function () {
      // always executed
      setIsLoading(false)
    });
    
  }
  }, [showDialog]);

//  Load CQA data from DB:

  useEffect(() => {
    if (showDialog===true) {

      // console.log(currentGridData)

      if (currentGridData.CQAData) {
        // console.log(currentGridData.CQAData)
        setTableData(currentGridData.CQAData)
      }
    }
    }, [showDialog]);

  // Data Validation:
  const [validationErrors, setValidationErrors] = useState<{
    [cellId: string]: string;
  }>({});
  // const validateRequired = (value: string) => !!value.length;
  const validateRequired = (value: string) => null;

  const validateTestID = (testID: string) => tableData.some(item => item.testID === testID);
  const validateDryDensity = (dryDensity: number) => dryDensity >= 0 && dryDensity <= 150;
  const validateMoistureContent = (moistureContent: number) => moistureContent >= 0 && moistureContent <= 50;



// update grid data from DB function:
  async function updateDBGridData() {

    const mainDBUrl = process.env.REACT_APP_CQA_POINTS_URL + currentGridID

    const updatedValues = currentGridData

    var filteredTableData = tableData.map(obj => {
      // Creating a new object to avoid mutating the original data
      var newObj = {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== "" && obj[key] !== null && obj[key] !== "NaN") {
          newObj[key] = obj[key]; // Copy over non-empty values
        }
      }
      return newObj; // Return the new object with empty string values removed
    });
    
    // console.log(filteredTableData)

    updatedValues.CQAData = filteredTableData
    updatedValues.initialElevation = Number(initialElevation)
    const currentSurveyElevation = calcCurrentSurveyElevation(tableData);
    console.log("currentSurveyElevation: ", currentSurveyElevation)
    if (currentSurveyElevation !== null) {
    updatedValues.elevation = Number(currentSurveyElevation)}
    else {
      updatedValues.elevation = Number(currentElevation)
    }
    getCurrentGridData(updatedValues)
    delete updatedValues['_id'];

    // console.log(process.env.REACT_APP_BACKEND_URL + mainDBUrl)
    console.log(updatedValues)

    if (updatedValues) {
      setIsLoading(true)
      axios.put(process.env.REACT_APP_BACKEND_URL + mainDBUrl, updatedValues).then(function (response) {
        // console.log(updatedValues);
    
        // console.log(response.data);
        // console.log("New data has been added!")

        setUpdateDBSuccess(true)
        console.log(`CQA Test "${currentRowValues && currentRowValues['testID']}" has been added/updated/deleted for Grid "${currentGridID}"!`)
      })
      .catch(function (error) {
        // handle error
        console.error(error);
        setUpdateDBSuccess(false)
        SetInputAlertType("error")
        SetInputAlertText(error)
      })
      .then(function () {
        // always executed
      })
      .finally(() => {
        setIsLoading(false);
      });
      };
  }


// Create new row:
  const createNewModalTitle = "Create New Record"
  const createNewModalConfirmButtonText = "Create"

  const handleCreateNewRow = async (values: CQADataType) => {
  // send new data row to table:
  // console.log(validationErrors)
  // console.log(tableData)
  // console.log(values)
  setCurrentRowValues(values)
  tableData.push(values);
  setTableData([...tableData]);
  setIsLoading(true);
  updateDBGridData()
  if (updateDBSuccess === true) {
    SetInputAlertType("success")
    SetInputAlertText(`CQA Test "${values && values['testID']}" has been added!`)
  }

};

// Update existing row:
const updateRowModalTitle = "Update Existing Record"
const updateRowModalConfirmButtonText = "Update"
const [updateModalOpen, setUpdateModalOpen] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);


const handleUpdateRowView = async (row: MRT_Row<CQADataType>) => {
  setSelectedRow(row);
  if (tableData && tableData.length>0 ) {
    setCurrentRowValues(tableData[row.index]);
} 
  // console.log(tableData)
  // console.log(row.index)
  setUpdateModalOpen(true);
}

// const handleUpdateRowView = useCallback(
//   (row: MRT_Row<CQADataType>) => {
//     setSelectedRow(row);
//     if (tableData && tableData.length>0 ) {
//       setCurrentRowValues(tableData[row.index]);
// } 
//     console.log(tableData)
//     console.log(row.index)
//     setUpdateModalOpen(true);
//   },
//   [],
// );

const handleConfirmUpdateRow = async (values: CQADataType) => {
  // send new data row to table:
  if (validationErrors) {
    // update data table in front view:
    const index = selectedRow.index;
    tableData[index] = values;
    // console.log(tableData)
    // console.log(values)
    setTableData([...tableData]);
    updateDBGridData()
    if (updateDBSuccess === true) {
      SetInputAlertType("info")
      SetInputAlertText(`CQA Test "${selectedRow && selectedRow.getValue('testID')}" has been updated!`)
    }
    }
  };

// Cancel row edits:
  const handleCancelRowEdits = () => {
    setValidationErrors({});
  };

  //  Delete data:
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  // const [selectedRow, setSelectedRow] = useState(null);

  const handleDeleteRow = useCallback(
    (row: MRT_Row<CQADataType>) => {
      setDeleteDialogOpen(true);
      setSelectedRow(row);
    },
    [],
  );

  const handleConfirmDelete = useCallback(
    () => {
      setDeleteDialogOpen(false);
      //send api delete request here, then refetch or update local table data for re-render
      const index = selectedRow.index;
// Delete document from DB:

      // delete row in data table in front view:
      if (index > -1) {
        tableData.splice(index, 1);
        setTableData([...tableData]);
      }
//  Delete data from DB:
      updateDBGridData()
      if (updateDBSuccess === true) {
        SetInputAlertType("warning")
        SetInputAlertText(`CQA Test "${selectedRow && selectedRow.getValue('testID')}" has been deleted!`)
      }

      },
      [tableData, selectedRow],      
      );

  const handleCloseDeleteDialog = useCallback(
    () => {
      setDeleteDialogOpen(false);
    },
    [],
  );

  const getCommonEditTextFieldProps = useCallback(
    (
      cell: MRT_Cell<CQADataType>,

    ): MRT_ColumnDef<CQADataType>['muiEditTextFieldProps'] => {
      
      return {
        error: !!validationErrors[cell.id],
        helperText: validationErrors[cell.id],
        onChange: (event) => {
        },
        onBlur: (event) => {
          // console.log(cell.id)
          const isRequired = validateRequired(event.target.value)
//  Validate required fields:
          if (!isRequired) {
            setValidationErrors({
              ...validationErrors,
              [cell.id]: `${cell.column.columnDef.header} is required`,
            });
          } else {
            //remove validation error for cell if valid
            delete validationErrors[cell.id];
            setValidationErrors({
              ...validationErrors,
            });
          }

//  Validate if testID is unique:
          if (cell.column.id === 'testID') {
            const isUnique = validateTestID(cell.column.id )
            // console.log(isUnique)
            if (!isUnique) {
              setValidationErrors({
                ...validationErrors,
                [cell.id]: 'This test ID already exists',
              });
            } else {
              //remove validation error for cell if valid
              delete validationErrors[cell.id];
              setValidationErrors({
                ...validationErrors,
              });
            }
          } 

  //  Validate if dryDensity is in the normal range:
          if (['maxDryDensity', 'dryDensity'].includes(cell.column.id)) {
            const isValid = validateDryDensity(parseFloat(event.target.value))
            // console.log(isValid)
            if (!isValid) {
              setValidationErrors({
                ...validationErrors,
                [cell.id]: 'This value is not in the normal range, please double check your input!',
              });
            } else {
              //remove validation error for cell if valid
              delete validationErrors[cell.id];
              setValidationErrors({
                ...validationErrors,
              });
            }
          } 

  //  Validate if moistureContent is in the normal range:
          if (cell.column.id === 'moistureContent') {
            const isValid = validateMoistureContent(parseFloat(event.target.value))
            // console.log(isValid)
            if (!isValid) {
              setValidationErrors({
                ...validationErrors,
                [cell.id]: 'This value is not in the normal range, please double check your input!',
              });
            } else {
              //remove validation error for cell if valid
              delete validationErrors[cell.id];
              setValidationErrors({
                ...validationErrors,
              });
            }
          } 

        },
      };
    },
    [validationErrors],
  );

  const columns = useMemo<MRT_ColumnDef<CQADataType>[]>(
    () => [
      {
        accessorKey: 'date',
        header: 'Date',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiTableBodyCellCopyButtonProps: {
          fullWidth: true,
          // startIcon: <ContentCopy />,
          sx: { justifyContent: 'flex-start' },
        },
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          // type: 'number',
        }),
      },
      {
        accessorKey: 'liftNo',
        header: 'Lift No.',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
      //   enableSorting: true,
        // muiTableBodyCellCopyButtonProps: {
        //   fullWidth: true,
        //   // startIcon: <ContentCopy />,
        //   sx: { justifyContent: 'flex-start' },
        // },
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        type: 'string',
        }),
      },
      {
        accessorKey: 'materialType',
        header: 'Material Type',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell, row }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'string',
        }),
      },
      {
        accessorKey: 'testType',
        header: 'Test Type',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell, row }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'string',
        }),
      },
      {
        accessorKey: 'testID',
        header: 'Test ID',
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        size: 80,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'string',
        }),
      },
      {
        accessorKey: 'previousSurveyElevation',
        header: 'Previous Survey Elevation (ft.)',
        size: 120,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      }, 
      {
        accessorKey: 'surveyElevation',
        header: 'Survey Elevation (ft.)',
        size: 120,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },      
      {
        accessorKey: 'liftThickness',
        header: 'Lift Thickness (in.)',
        size: 120,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      }, 
      {
        accessorKey: 'requiredLowerBoundLiftThickness',
        header: 'Required Min. Lift Thickness (in.)',
        size: 120,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },
      {
        accessorKey: 'requiredUpperBoundLiftThickness',
        header: 'Required Max. Lift Thickness (in.)',
        size: 120,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },
      {
        accessorKey: 'dryDensity',
        header: 'Dry Density (PCF)',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },
      {
        accessorKey: 'moistureContent',
        header: 'Moisture Content (%)',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },
      {
        accessorKey: 'wetDensity',
        header: 'Wet Density (PCF)',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
          disabled: true,
        }),
      },
      {
        accessorKey: 'proctorTestID',
        header: 'Proctor Test ID',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'string',
        }),
      },
      {
        accessorKey: 'optimumMoistureContent',
        header: 'Optimum Moisture Content (%)',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },
      {
        accessorKey: 'maxDryDensity',
        header: 'Maximum Dry Density (PCF)',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },
      {
        accessorKey: 'percentageCompaction',
        header: 'Percentage Compaction (%)',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
          disabled: true,
        }),
      },
      {
        accessorKey: 'requiredPercentageCompaction',
        header: 'Required Percentage Compaction (%)',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },
      {
        accessorKey: 'requiredLowerBoundMoistureContent',
        header: 'Required Lower Bound MC (%)',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },
      {
        accessorKey: 'requiredUpperBoundMoistureContent',
        header: 'Required Upper Bound MC (%)',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'number',
        }),
      },
      {
        accessorKey: 'passOrRetest',
        header: 'Pass or Retest',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'string',
        }),
      },
      {
        accessorKey: 'notes',
        header: 'Notes',
        size: 80,
        enableColumnOrdering: true,
        enableClickToCopy: true,
        enableEditing: true, 
        enableSorting: true,
        muiEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'string',
        }),
      },
    ],
    [getCommonEditTextFieldProps],
  );

//   const [currentRowValues, setCurrentRowValues] = useState<any>(() => {
//     return columns.reduce((acc, column) => {
//       acc[column.accessorKey ?? ''] = '';
//       if (column.accessorKey === 'testType') {
//         acc[column.accessorKey ?? ''] = "";
//       } else if (column.accessorKey === 'requiredPercentageCompaction') {
//         acc[column.accessorKey ?? ''] = 95;
//       } else if (column.accessorKey === 'date') {
//         acc[column.accessorKey ?? ''] = dayjs(new Date()).format('MM/DD/YYYY');
//       }
//       return acc;
//     }, {} as any)
  
// });
    const [currentRowValues, setCurrentRowValues] = useState<any>({})

    const dataTable = useMaterialReactTable({
      displayColumnDefOptions: {
        'mrt-row-actions': {
          muiTableHeadCellProps: {
            align: 'center',
          },
          size: 120,
        },
      },
      columns: columns,
      data: tableData,
      createDisplayMode: 'modal',
      editDisplayMode: "modal", //default
      enableEditing: true,
      enableColumnOrdering:true,
      enableRowActions: true,
      enableColumnPinning: true,
      // enableEditing:true,
      // onEditingRowSave: handleSaveRowEdits,
      onEditingRowCancel: handleCancelRowEdits,
      initialState: {
        columnVisibility: { _id: false },
        columnPinning: { left: ['mrt-row-actions', 'testID'], right: [] },
      
      }, 
      muiTableBodyRowProps: ({
        row
      }) => ({
        // sx: {
        //   backgroundColor: row.getValue<string>('passOrRetest') === "Pass" ? 'rgba(0, 255, 0, 0.3)' : row.getValue<string>('passOrRetest') === "Retest" ? 'rgba(0, 0, 255, 0.3)' : 'rgba(255, 128, 0, 0.3)',
        //   fontStyle: 'italic'
        // }
      }),

      renderRowActions: ({row}) => (
        <Box sx={{ display: 'flex', gap: '1rem' }}>

          <Tooltip arrow placement="left" title="Edit">
            <IconButton onClick={() => {
              handleUpdateRowView(row)
            }}>
              {/* <Edit /> */}
              {
                row.getValue<string>('passOrRetest') === "Pass" ? <ThumbUpAlt color="success" /> : row.getValue<string>('passOrRetest') === "Retest" ? <ThumbDownAlt color="info" /> : <QuestionMark color="warning"/>

              }
            </IconButton>
          </Tooltip>
          <Tooltip arrow placement="right" title="Delete">
            <IconButton color="error" onClick={() => {
              // console.log(tableData[row.index])
              handleDeleteRow(row)
              }}>
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      ),
      renderTopToolbarCustomActions: () => (
        <div style={{width: "100%",}}>
          {showAlert && 
            <Alert 
          severity={inputAlertType}
          sx={{ 
            p: '0rem', 
            m: '1.25rem', 
            backgroundColor: 'transparent',
        }} 
          // color={inputAlertType}
          style={ inputAlertText!=='' ? {display:"flex"} : {display:"none"}}
          >
              <AlertTitle>{inputAlertText}</AlertTitle>
              {/* {error} */}
            </Alert>       
            }
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            {/* initial elevation input: */}
            <TextField
              style={{color: "white", margin: '1rem'}}
              // required
              key="initialElevation"
              label="Initial Elevation (ft.)"
              name="initialElevation"
              type="number"
              value= {initialElevation}
              onChange={(e) => {
                setInitialElevation(e.target.value);
                // console.log(e.target.value);
              }}
              onBlur={updateDBGridData}
          />
            <TextField
                style={{color: "white", marginRight: '1rem'}}       
                // required
                key="currentElevation"
                label="Current Elevation (ft.)"
                name="currentElevation"
                type="number"
                value= {currentElevation}
                onChange={(e) => {
                  setCurrentElevation(e.target.value );
                  // console.log(e.target.value);
                }

                }
                onBlur={updateDBGridData}
              />
            <Button
              style={{marginRight: '1em'}}
              color="success"
              onClick={() => setCreateModalOpen(true)}
              variant="contained"
            >
              Create New Record
            </Button>
          </div>

        </div>
      ),

    })

    return (
      <>
      {isLoading && (
              <MapLoadingComponent/>
            )}

      <MaterialReactTable 
      table = {dataTable}
      />

      {/* create new row modal */}
      <CreateUpdateRecordModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
        tableData= {tableData}
        currentGridID = {currentGridID}
        proctorTableData = {proctorTableData}
        title = {createNewModalTitle}
        confirmButtonText = {createNewModalConfirmButtonText}
        currentRowIndex={selectedRow ? selectedRow.index : 0}
        values = {currentRowValues}
        setValues = {setCurrentRowValues}
        initialElevation = {initialElevation}
        currentElevation = {currentElevation}
        setCurrentElevation = {setCurrentElevation}
      />
      {/* update existing row modal */}
      <CreateUpdateRecordModal
        columns={columns}
        open={updateModalOpen}
        onClose={() => setUpdateModalOpen(false)}
        onSubmit={handleConfirmUpdateRow}
        tableData= {tableData}
        currentGridID = {currentGridID}
        proctorTableData = {proctorTableData}
        title = {updateRowModalTitle}
        confirmButtonText = {updateRowModalConfirmButtonText}
        currentRowIndex={selectedRow ? selectedRow.index : 0}
        values = {currentRowValues}
        setValues = {setCurrentRowValues}
        initialElevation = {initialElevation}
        currentElevation = {currentElevation}
        setCurrentElevation = {setCurrentElevation}
      />


      {/* delete row dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete "${selectedRow && selectedRow.getValue('testID')}"?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="warning" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>



      {/* {isLoading && (
              <LoadingComponent/>
            )} */}
    </>
    );
  };
  
  export default FillGridCQAInputTable;